import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "elemental-reaction" }
const _hoisted_2 = { for: "増幅反応-なし" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  for: "増幅反応-蒸発_炎",
  class: "pyro"
}
const _hoisted_5 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  for: "増幅反応-蒸発_水",
  class: "hydro"
}
const _hoisted_8 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  for: "増幅反応-溶解_氷",
  class: "cryo"
}
const _hoisted_11 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_12 = { key: 3 }
const _hoisted_13 = {
  for: "増幅反応-溶解_炎",
  class: "pyro"
}
const _hoisted_14 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { for: "増幅反応-超激化" }
const _hoisted_17 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_18 = { key: 5 }
const _hoisted_19 = { for: "増幅反応-草激化" }
const _hoisted_20 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_21 = { key: 6 }
const _hoisted_22 = { class: "pyro" }
const _hoisted_23 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_24 = { key: 7 }
const _hoisted_25 = { class: "electro" }
const _hoisted_26 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_27 = { key: 8 }
const _hoisted_28 = { class: "cryo" }
const _hoisted_29 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_30 = { key: 9 }
const _hoisted_31 = { key: 10 }
const _hoisted_32 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_33 = { key: 11 }
const _hoisted_34 = { class: "pyro" }
const _hoisted_35 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_36 = { key: 12 }
const _hoisted_37 = { class: "dendro" }
const _hoisted_38 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_39 = { key: 13 }
const _hoisted_40 = { class: "dendro" }
const _hoisted_41 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_42 = { key: 14 }
const _hoisted_43 = { class: "dendro" }
const _hoisted_44 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_45 = { key: 15 }
const _hoisted_46 = { class: "cryo" }
const _hoisted_47 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_48 = {
  key: 16,
  class: "with-tooltip"
}
const _hoisted_49 = { class: "electro lunar" }
const _hoisted_50 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_51 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_52 = {
  key: 17,
  class: "with-tooltip"
}
const _hoisted_53 = { class: "geo lunar" }
const _hoisted_54 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_55 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_56 = {
  key: 18,
  class: "with-tooltip"
}
const _hoisted_57 = { class: "anemo lunar" }
const _hoisted_58 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_59 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_60 = {
  key: 19,
  class: "with-tooltip stella"
}
const _hoisted_61 = { class: "cryo lunar" }
const _hoisted_62 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_63 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_64 = {
  key: 20,
  class: "with-tooltip stella"
}
const _hoisted_65 = { class: "cryo lunar" }
const _hoisted_66 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_67 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_68 = {
  key: 0,
  class: "result v-style"
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["rowspan"]
const _hoisted_71 = ["innerHTML"]
const _hoisted_72 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_73 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_74 = {
  key: 0,
  class: "savepoint"
}
const _hoisted_75 = {
  key: 1,
  class: "result h-style"
}
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["colspan"]
const _hoisted_78 = { class: "result damage-result" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { class: "notes" }
const _hoisted_81 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("input", {
          id: "増幅反応-なし",
          type: "radio",
          value: "なし",
          name: "増幅反応-name",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.増幅反応 = 'なし')),
          checked: ""
        }, null, 32),
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.displayName("反応なし")), 1)
      ]),
      (_ctx.damageResult.元素反応.蒸発倍率_炎)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("input", {
              id: "増幅反応-蒸発_炎",
              type: "radio",
              value: "蒸発_炎",
              name: "増幅反応-name",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.増幅反応 = '蒸発_炎'))
            }, null, 32),
            _createElementVNode("label", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.displayName("蒸発")) + "×", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.蒸発倍率_炎 * 100) / 100), 1),
              (_ctx.copiedDamageResult?.元素反応?.蒸発倍率_炎)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("蒸発")) + "×", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.蒸発倍率_炎 * 100) / 100), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.蒸発倍率_水)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("input", {
              id: "増幅反応-蒸発_水",
              type: "radio",
              value: "蒸発_水",
              name: "増幅反応-name",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.増幅反応 = '蒸発_水'))
            }, null, 32),
            _createElementVNode("label", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.displayName("蒸発")) + "×", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.蒸発倍率_水 * 100) / 100), 1),
              (_ctx.copiedDamageResult?.元素反応?.蒸発倍率_水)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("蒸発")) + "×", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.蒸発倍率_水 * 100) / 100), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.溶解倍率_氷)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("input", {
              id: "増幅反応-溶解_氷",
              type: "radio",
              value: "溶解_氷",
              name: "増幅反応-name",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.増幅反応 = '溶解_氷'))
            }, null, 32),
            _createElementVNode("label", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.displayName("溶解")) + "×", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.溶解倍率_氷 * 100) / 100), 1),
              (_ctx.copiedDamageResult?.元素反応?.溶解倍率_氷)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("溶解")) + "×", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.溶解倍率_氷 * 100) / 100), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.溶解倍率_炎)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("input", {
              id: "増幅反応-溶解_炎",
              type: "radio",
              value: "溶解_炎",
              name: "増幅反応-name",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.増幅反応 = '溶解_炎'))
            }, null, 32),
            _createElementVNode("label", _hoisted_13, [
              _createTextVNode(_toDisplayString(_ctx.displayName("溶解")) + "×", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.溶解倍率_炎 * 100) / 100), 1),
              (_ctx.copiedDamageResult?.元素反応?.溶解倍率_炎)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("溶解")) + "×", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.溶解倍率_炎 * 100) / 100), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.超激化反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("input", {
              id: "増幅反応-超激化",
              type: "radio",
              value: "超激化",
              name: "増幅反応-name",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.増幅反応 = '超激化'))
            }, null, 32),
            _createElementVNode("label", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.displayName("超激化")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.超激化反応ダメージ)), 1),
              (_ctx.copiedDamageResult?.元素反応?.超激化反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("超激化")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.超激化反応ダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.草激化反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("input", {
              id: "増幅反応-草激化",
              type: "radio",
              value: "草激化",
              name: "増幅反応-name",
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.増幅反応 = '草激化'))
            }, null, 32),
            _createElementVNode("label", _hoisted_19, [
              _createTextVNode(_toDisplayString(_ctx.displayName("草激化")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.草激化反応ダメージ)), 1),
              (_ctx.copiedDamageResult?.元素反応?.草激化反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("草激化")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.草激化反応ダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.過負荷反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, [
              _createTextVNode(_toDisplayString(_ctx.displayName("過負荷")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.過負荷反応ダメージ)), 1),
              (_ctx.copiedDamageResult?.元素反応?.過負荷反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("過負荷")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.過負荷反応ダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.感電反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, [
              _createTextVNode(_toDisplayString(_ctx.displayName("感電")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.感電反応ダメージ)), 1),
              (_ctx.copiedDamageResult?.元素反応?.感電反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                    _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("感電")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.感電反応ダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.超電導反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("label", _hoisted_28, [
              _createTextVNode(_toDisplayString(_ctx.displayName("超電導")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.超電導反応ダメージ)), 1),
              (_ctx.copiedDamageResult?.元素反応?.超電導反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                    _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("超電導")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.超電導反応ダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.拡散反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("label", {
              class: _normalizeClass(_ctx.elementClass(_ctx.damageResult.元素反応.拡散元素))
            }, [
              _createTextVNode(_toDisplayString(_ctx.displayName("拡散")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.swirlDmg)), 1)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.結晶吸収量)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("label", null, [
              _createTextVNode(_toDisplayString(_ctx.displayName("結晶")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.damageResult.元素反応.結晶吸収量)), 1),
              (_ctx.copiedDamageResult?.元素反応?.結晶吸収量)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                    _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("結晶")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.結晶吸収量)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.燃焼反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("label", _hoisted_34, [
              _createTextVNode(_toDisplayString(_ctx.displayName("燃焼")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.reactionDmg('燃焼反応ダメージ'))), 1),
              (_ctx.copiedDamageResult?.元素反応?.燃焼反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("燃焼")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.燃焼反応ダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.開花反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("label", _hoisted_37, [
              _createTextVNode(_toDisplayString(_ctx.displayName("開花")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.reactionDmg('開花反応ダメージ'))), 1),
              (_ctx.copiedDamageResult?.元素反応?.開花反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                    _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("開花")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.開花反応ダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.烈開花反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("label", _hoisted_40, [
              _createTextVNode(_toDisplayString(_ctx.displayName("烈開花")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.reactionDmg('烈開花反応ダメージ'))), 1),
              (_ctx.copiedDamageResult?.元素反応?.烈開花反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                    _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("烈開花")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.烈開花反応ダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.超開花反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("label", _hoisted_43, [
              _createTextVNode(_toDisplayString(_ctx.displayName("超開花")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.reactionDmg('超開花反応ダメージ'))), 1),
              (_ctx.copiedDamageResult?.元素反応?.超開花反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                    _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("超開花")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.超開花反応ダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.氷砕きダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("label", _hoisted_46, [
              _createTextVNode(_toDisplayString(_ctx.displayName("氷砕き")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.reactionDmg('氷砕きダメージ'))), 1),
              (_ctx.copiedDamageResult?.元素反応?.氷砕きダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                    _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("氷砕き")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedDamageResult.元素反応.氷砕きダメージ)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.月感電反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("label", _hoisted_49, [
              _createTextVNode(_toDisplayString(_ctx.displayName("月感電")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.lunarReactionDmg('月感電反応ダメージ'))), 1),
              (_ctx.copiedDamageResult?.元素反応?.月感電反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                    _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("月感電")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedLunarReactionDmg('月感電反応ダメージ'))), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.damageResult.元素反応.月感電反応ダメージ会心率)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('期待値')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('会心')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('非会心')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.damageResult.元素反応.月感電反応ダメージALL, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[2])), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[3] || 0)), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[4])), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.月結晶反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _createElementVNode("label", _hoisted_53, [
              _createTextVNode(_toDisplayString(_ctx.displayName("月結晶")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.lunarReactionDmg('月結晶反応ダメージ'))), 1),
              (_ctx.copiedDamageResult?.元素反応?.月結晶反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                    _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("月結晶")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedLunarReactionDmg('月結晶反応ダメージ'))), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.damageResult.元素反応.月結晶反応ダメージ会心率)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('期待値')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('会心')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('非会心')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.damageResult.元素反応.月結晶反応ダメージALL, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[2])), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[3] || 0)), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[4])), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.星拡散反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("label", _hoisted_57, [
              _createTextVNode(_toDisplayString(_ctx.displayName("星拡散")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.lunarReactionDmg('星拡散反応ダメージ'))), 1),
              (_ctx.copiedDamageResult?.元素反応?.星拡散反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                    _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("星拡散")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedLunarReactionDmg('星拡散反応ダメージ'))), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.damageResult.元素反応.星拡散反応ダメージ会心率)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('期待値')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('会心')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('非会心')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.damageResult.元素反応.星拡散反応ダメージALL, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[2])), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[3] || 0)), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[4])), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.星の嵐反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            _createElementVNode("label", _hoisted_61, [
              _createTextVNode(_toDisplayString(_ctx.displayName("星の嵐Lv1")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.lunarReactionDmg('星の嵐反応ダメージ'))), 1),
              (_ctx.copiedDamageResult?.元素反応?.星の嵐反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                    _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("星の嵐Lv1")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedLunarReactionDmg('星の嵐反応ダメージ'))), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.damageResult.元素反応.星の嵐反応ダメージ会心率)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('期待値')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('会心')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('非会心')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.damageResult.元素反応.星の嵐反応ダメージALL, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[2])), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[3] || 0)), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[4])), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.damageResult.元素反応.星の嵐反応ダメージ)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("label", _hoisted_65, [
              _createTextVNode(_toDisplayString(_ctx.displayName("星の嵐Lv2")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.lunarReactionDmg('星の嵐反応ダメージ') * 1.5)), 1),
              (_ctx.copiedDamageResult?.元素反応?.星の嵐反応ダメージ)
                ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                    _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.displayName("星の嵐Lv2")) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.copiedLunarReactionDmg('星の嵐反応ダメージ') * 1.5)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.damageResult.元素反応.星の嵐反応ダメージ会心率)
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('期待値')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('会心')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.displayName('非会心')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.damageResult.元素反応.星の嵐反応ダメージALL, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[2] * 1.5)), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round((item[3] || 0) * 1.5)), 1),
                          _createElementVNode("td", null, _toDisplayString(Math.round(item[4] * 1.5)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("fieldset", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CATEGORY_LIST, (category) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: category }, [
          (_ctx.damageResult[category] && _ctx.itemList(category).length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.resultStyleRef == '1')
                  ? (_openBlock(), _createElementBlock("table", _hoisted_68, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", {
                          onClick: ($event: any) => (_ctx.categoryOnClick(category))
                        }, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.displayName(category)), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.displayName("期待値")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.displayName("会心")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.displayName("非会心")), 1)
                        ], 8, _hoisted_69)
                      ]),
                      _createElementVNode("tbody", null, [
                        (_ctx.categoryOpenClose[category])
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.itemList(category), (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                (item[item.length - 1])
                                  ? (_openBlock(), _createElementBlock("th", {
                                      key: 0,
                                      class: "with-tooltip",
                                      rowspan: item[item.length - 1]
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.displayNameV(item[0])), 1),
                                      (_ctx.displayDamageParam(item))
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "tooltip",
                                            innerHTML: _ctx.displayDamageParam(item)
                                          }, null, 8, _hoisted_71))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_70))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", {
                                  class: _normalizeClass('damage-value ' + _ctx.elementClass(item[1], item[5]))
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.displayDamageValue(item, 2, category)) + " ", 1),
                                  (_ctx.displayCopiedDamageValue(index, 2, category))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                                        _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.displayCopiedDamageValue(index, 2, category)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("td", {
                                  class: _normalizeClass('damage-value ' + _ctx.elementClass(item[1], item[5]))
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.displayDamageValue(item, 3, category)) + " ", 1),
                                  (_ctx.displayCopiedDamageValue(index, 3, category))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                                        _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.displayCopiedDamageValue(index, 3, category)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("td", {
                                  class: _normalizeClass('damage-value ' + _ctx.elementClass(item[1], item[5]))
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.displayDamageValue(item, 4, category)) + " ", 1),
                                  (_ctx.displayCopiedDamageValue(index, 4, category))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, [
                                        _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.displayCopiedDamageValue(index, 4, category)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.resultStyleRef == '0')
                  ? (_openBlock(), _createElementBlock("table", _hoisted_75, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", {
                          onClick: ($event: any) => (_ctx.categoryOnClick(category))
                        }, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.displayName(category)), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList(category), (item) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: item[0]
                            }, [
                              (item[item.length - 1])
                                ? (_openBlock(), _createElementBlock("th", {
                                    key: 0,
                                    colspan: item[item.length - 1]
                                  }, _toDisplayString(_ctx.displayNameH(item[0], category)), 9, _hoisted_77))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 8, _hoisted_76)
                      ]),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.displayName("期待値")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList(category), (item) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: item[0],
                              class: _normalizeClass('damage-value ' + _ctx.elementClass(item[1], item[5]))
                            }, _toDisplayString(_ctx.displayDamageValue(item, 2, category)), 3))
                          }), 128))
                        ]),
                        (_ctx.categoryOpenClose[category])
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.displayName("会心")), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList(category), (item) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: item[0],
                                    class: _normalizeClass('damage-value ' + _ctx.elementClass(item[1], item[5]))
                                  }, _toDisplayString(_ctx.displayDamageValue(item, 3, category)), 3))
                                }), 128))
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.displayName("非会心")), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList(category), (item) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: item[0],
                                    class: _normalizeClass('damage-value ' + _ctx.elementClass(item[1], item[5]))
                                  }, _toDisplayString(_ctx.displayDamageValue(item, 4, category)), 3))
                                }), 128))
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _cache[33] || (_cache[33] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("table", _hoisted_78, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.displayName("被ダメージ")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.damageTakenList, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                class: "damage-value",
                key: item.key
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.elementClass(item.key))
                }, _toDisplayString(Math.round(item.value)), 3)
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.displayName("耐久スコア")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resScoreList, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                class: "damage-value",
                key: item.key
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.elementClass(item.key))
                }, _toDisplayString(Math.round(item.value)), 3)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.copyDamageResult && _ctx.copyDamageResult(...args)))
      }, _toDisplayString(_ctx.displayName('比較用に現在値を記憶')), 1),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearCopiedDamageResult && _ctx.clearCopiedDamageResult(...args)))
      }, _toDisplayString(_ctx.displayName('削除')), 1)
    ]),
    (_ctx.damageResult.キャラクター注釈.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
          _createElementVNode("ul", _hoisted_80, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.damageResult.キャラクター注釈, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_81, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.resultStyleRef) = $event))
        }, _cache[34] || (_cache[34] = [
          _createElementVNode("option", { value: "1" }, "V-style", -1),
          _createElementVNode("option", { value: "0" }, "H-style", -1)
        ]), 512), [
          [_vModelSelect, _ctx.resultStyleRef]
        ])
      ])
    ])
  ], 64))
}